
import React from 'react';
import { CheckCircle, XCircle } from 'lucide-react';
import ReportSection from '@/components/report/ReportSection';

interface StrengthsWeaknessesProps {
  strengths: string[];
  weaknesses: string[];
}

const StrengthsWeaknesses: React.FC<StrengthsWeaknessesProps> = ({ strengths, weaknesses }) => {
  return (
    <div className="grid md:grid-cols-2 gap-6 mb-10">
      <ReportSection title="Pontos Fortes" icon={<CheckCircle size={22} />} className="mb-0">
        <ul className="space-y-3">
          {strengths.map((strength, index) => (
            <li key={index} className="flex items-start">
              <CheckCircle size={18} className="text-green-500 mt-0.5 mr-2 flex-shrink-0" />
              <span>{strength}</span>
            </li>
          ))}
        </ul>
      </ReportSection>
      
      <ReportSection title="Pontos Fracos" icon={<XCircle size={22} />} className="mb-0">
        <ul className="space-y-3">
          {weaknesses.map((weakness, index) => (
            <li key={index} className="flex items-start">
              <XCircle size={18} className="text-red-500 mt-0.5 mr-2 flex-shrink-0" />
              <span>{weakness}</span>
            </li>
          ))}
        </ul>
      </ReportSection>
    </div>
  );
};

export default StrengthsWeaknesses;
